exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sc-card-container[data-v-0dcd9576]{display:inline-block;border:1px solid #d3dadf}.sc-card-slot[data-v-0dcd9576]{margin:15px 10px;text-align:left}.sc-card-title-slot[data-v-0dcd9576]{color:#37474f;font-weight:600}", ""]);

// exports
